export const PAGE_HEADER_TAG_NAME = "pageHeader" as const;

export const PAGE_HEADER_VISUAL_TAG_NAME = "pageHeaderVisual" as const;

export const PAGE_HEADER_CONTENT_TAG_NAME = "pageHeaderContent" as const;

export const PAGE_HEADER_BREADCRUMB_TAG_NAME = "pageHeaderBreadcrumb" as const;

export const PAGE_HEADER_HEADING_TAG_NAME = "pageHeaderHeading" as const;

export const PAGE_HEADER_META_TAG_NAME = "pageHeaderMeta" as const;

export const PAGE_HEADER_ACTIONS_TAG_NAME = "pageHeaderActions" as const;

export const PAGE_HEADER_VARIANTS = ["card", "plain", "bare"] as const;

export const PAGE_HEADER_SLOT = "page-header" as const;

export const MIN_CONTENT_WIDTH_PX = 320;
